import { api } from '../../../plugins/api'
import { NotificacaoPortariaRepository } from './notificacao-portaria-repository'

export * from './filter'
export * from './notificacao-portaria'
export * from './notificacao-portaria-repository'

export const notificacao_portaria_repository = new NotificacaoPortariaRepository(api)
